import React from 'react'

const SquareLogo = ({ backgroundColor = '#032438', color = '#FFFFFF' }) => (
   <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 190 190"
      width="60"
      height="60"
   >
      <defs>
         <text
            id="logoText"
            x="321.52"
            y="174.55"
            fontSize="28"
            fontFamily="Righteous, sans-serif"
            fontWeight="normal"
            fontStyle="normal"
            letterSpacing="0"
            alignmentBaseline="before-edge"
            transform="matrix(1 0 0 1 -313.6363636363637 -81.06060606060603)"
            dominantBaseline="text-before-edge"
         >
            <tspan
               x="321.52"
               dy="0em"
               alignmentBaseline="before-edge"
               dominantBaseline="text-before-edge"
               textAnchor="start"
            >
               build
            </tspan>
            <tspan
               x="321.52"
               dy="1em"
               alignmentBaseline="before-edge"
               dominantBaseline="text-before-edge"
               textAnchor="start"
            >
               like
            </tspan>
            <tspan
               x="321.52"
               dy="1em"
               alignmentBaseline="before-edge"
               dominantBaseline="text-before-edge"
               textAnchor="start"
            >
               beavers®
            </tspan>
         </text>
         <path d="M0 0L190 0L190 190L0 190L0 0Z" id="logoBackground" />
      </defs>
      <g>
         <g>
            <use
               href="#logoBackground"
               opacity="1"
               fill={backgroundColor}
               fillOpacity="1"
            />
         </g>
         <g>
            <use href="#logoText" opacity="1" fill={color} fillOpacity="1" />
         </g>
      </g>
   </svg>
)

export default SquareLogo
